import $ from 'jquery';
export const init = async function() {
    const section = document.querySelector('.js-quotes');
    const blocks = section === null || section === void 0 ? void 0 : section.querySelectorAll('.LandingpageQuotes-block');
    if (blocks === null || blocks === void 0 ? void 0 : blocks.length) {
        var _blocks_;
        (_blocks_ = blocks[0]) === null || _blocks_ === void 0 ? void 0 : _blocks_.classList.add('active');
    }
    blocks === null || blocks === void 0 ? void 0 : blocks.forEach((block)=>{
        const logo = block === null || block === void 0 ? void 0 : block.querySelector('.LandingpageQuotes-logo');
        logo === null || logo === void 0 ? void 0 : logo.addEventListener('click', function() {
            $('.LandingpageQuotes-block').removeClass('active');
            block.classList.add('active');
        });
    });
};
